import { render, staticRenderFns } from "./MoblieDetails.vue?vue&type=template&id=0455b300&scoped=true&"
import script from "./MoblieDetails.vue?vue&type=script&lang=js&"
export * from "./MoblieDetails.vue?vue&type=script&lang=js&"
import style0 from "./MoblieDetails.vue?vue&type=style&index=0&id=0455b300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455b300",
  null
  
)

export default component.exports